import request from '@/utils/request';

// 创建非集合标签
export function insertOrUpdateGroupAndRule(values) {
  return request('/profile/group/insertOrUpdateGroupAndRule', {
    method: 'POST',
    data: values,
  });
}

// 非集合标签详情
export function queryTagAndRule(values) {
  return request('/profile/tag/queryTagAndRule', {
    method: 'POST',
    data: values,
  });
}

// 下载模版
export function downloadTemplate(values) {
  return request('/blacklist/downloadTemplate', {
    method: 'GET',
    data: values,
  });
}

// 字段列表
export function queryFileList(values) {
  return request('/profile/file/queryFileList', {
    method: 'POST',
    data: values,
  });
}

// 标签规则操作框的维度表数据
export function getQueryTagOperatorValue(values) {
  return request('/profile/tag/rule/queryTagOperatorValue', {
    method: 'POST',
    data: values,
  });
}

// 行为列表
export function queryTagBehaviorList(values) {
  return request('/profile/tag/queryTagBehaviorList', {
    method: 'POST',
    data: values,
  });
}

// 取值方式
export function queryTagBehaviorConditionList(values) {
  return request('/profile/tag/queryTagBehaviorConditionList', {
    method: 'POST',
    data: values,
  });
}

// 人群导入字段配置
export function queryGroupImportConfigList(values) {
  return request('/profile/group/queryGroupImportConfigList', {
    method: 'POST',
    data: values,
  });
}
